import { useGetIntegrationsQuery } from '@carboncopyco/data';
import { NoticeIcon } from '@carboncopyco/icons';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import {
  Banner,
  ColorHex,
  ColorNames,
  InlineLink,
  TextBase,
} from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import { useEffect } from 'react';
import { useMatch, useParams } from 'react-router-dom';
import { usePermissionsContext } from '../utils';

type IntegrationErrorBannerProps = {
  goToIntegrations?: () => void;
};

export const IntegrationErrorBanner = ({
  goToIntegrations,
}: IntegrationErrorBannerProps) => {
  const { getPermissions } = usePermissionsContext();
  const updateRolePermission = getPermissions(
    PermissionKey.roles,
    PermissionAction.updateRoleById
  );
  const { organizationId } = useParams();
  const [showIntegrationBanner, setShowIntegrationBanner] = useBoolean();
  const { data: activeIntegrations } = useGetIntegrationsQuery({
    organizationId: Number(organizationId),
  });
  const isIntegrationSettingsRoute = useMatch(
    `${organizationId}/settings/integrations`
  );

  useEffect(() => {
    if (
      activeIntegrations?.some(
        (integration) =>
          integration.renewalRequired || integration.integrationStatus === 'red'
      )
    ) {
      setShowIntegrationBanner.setTrue();
    }
  }, [activeIntegrations, setShowIntegrationBanner]);

  if (!showIntegrationBanner || !updateRolePermission) {
    return null;
  }

  return (
    <Banner
      danger
      containedWidth
      label=""
      content={
        <div className="flex flex-row items-center gap-2">
          <NoticeIcon
            size={20}
            color={ColorHex.danger500}
          />
          <div className="flex flex-row items-center gap-1">
            <div>
              <TextBase
                color={ColorNames.danger500}
                label="One or more of your integrations is disconnected."
              />
            </div>
            {!isIntegrationSettingsRoute && (
              <div className="flex flex-row items-center gap-1.5">
                <div>
                  <TextBase
                    color={ColorNames.danger500}
                    label="Visit the"
                  />
                </div>
                <InlineLink
                  fontFamily="font-ds-inter"
                  color={ColorNames.danger500}
                  label={'integrations page'}
                  onClick={goToIntegrations}
                />
                <div>
                  <TextBase
                    color={ColorNames.danger500}
                    label="to reconnect"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      }
      onClose={setShowIntegrationBanner.setFalse}
    />
  );
};
